import React, { Component } from 'react';
import { Table, Button, UncontrolledTooltip } from 'reactstrap';

const styles = {
  cellStyle: {
    verticalAlign: 'middle',
    textAlign: 'center'
  }
};
// for UncontrolledTooltip
const generateId = str => {
  let hex = '';
  // eslint-disable-next-line
  for (let i = 0; i < str.length; i++) {
    hex += `${str.charCodeAt(i).toString(16)}`;
  }
  return `id${hex}`;
};

class SelectedTable extends Component {
  state = {};
  render() {
    return (
      <Table striped responsive className="table-borderless">
        <thead>
          <tr style={{ fontSize: '0.9rem' }}>
            <th />
            <th style={{ textAlign: 'center' }}>Equipo</th>
            <th style={{ textAlign: 'center' }}>Cantidad</th>
            <th style={{ textAlign: 'center' }}>Potencia (W)</th>
            <th style={{ textAlign: 'center' }}>Horas Uso (h)</th>
            <th style={{ textAlign: 'center' }}>Consumo (Wh)</th>
            <th style={{ textAlign: 'center' }}>Línea</th>
          </tr>
        </thead>

        <tbody>
          {this.props.rows.map(item => {
            const { cantidad, horas, selectedOption, nombre, potencia } = item;
            const actualItem = selectedOption || item;
            const actualName = selectedOption ? selectedOption.nombre : nombre;
            const actualPot = selectedOption ? selectedOption.potencia : potencia;
            return (
              <tr key={actualName} style={{ fontSize: '0.9rem' }}>
                <td>
                  {selectedOption ? (
                    <img
                      {...selectedOption.cover.childImageSharp.responsiveSizes}
                      alt={actualName}
                      style={{ padding: 0, margin: 0, maxWidth: 50 }}
                    />
                  ) : (
                    ''
                  )}{' '}
                </td>
                <td style={{ ...styles.cellStyle }}>{actualName}</td>
                <td style={{ ...styles.cellStyle }}>{cantidad}</td>
                <td style={{ ...styles.cellStyle }}>{actualPot}</td>
                <td style={{ ...styles.cellStyle }}>{horas}</td>
                <td style={{ ...styles.cellStyle }}>{actualPot * horas * cantidad}</td>
                <td style={{ ...styles.cellStyle }}>{selectedOption && selectedOption.grupo}</td>
                <td style={{ ...styles.cellStyle, paddingTop: 0, paddingBottom: 0 }}>
                  <Button
                    color="link"
                    size="sm"
                    onClick={() => this.props.onRemove(actualItem)}
                    id={`${generateId(actualName)}`}
                  >
                    <span className="u-icon-v3" style={{ color: 'crimson' }}>
                      <i className="icon-trash" />
                    </span>
                  </Button>
                  <UncontrolledTooltip target={`${generateId(actualName)}`}>
                    Quitar
                  </UncontrolledTooltip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    );
  }
}

export default SelectedTable;



// WEBPACK FOOTER //
// ./src/components/Home/CalculadoraConsumo/Table/index.js